import * as THREE from "three";
import rendertotexture from "./rtt";

let cmt;

let rtTexture, rttplanemesh, sceneRTT, cameraRTT;


export default function updateworldgrid(worldgrid, camerabox, tilesize, scene, innercamerabox, renderer) {


    const target = new THREE.Vector3();

    function movegrid(vector, negative, resettracker, tilesize) {
        //negative pos to postive pos
        //Z: chunk.centerv.z * -1 * 2 + tilesize
        //X: chunk.centerv.x * 1 * 2 + tilesize
    
        //postive pos to negative pos
        //Z: chunk.centerv.z * 2 - tilesize
        //X: chunk.centerv.x * -2 - tilesize
    
        //select group index
    
            //Currently moved tracker
        if (negative === true) {
              if (cmt === worldgrid.lowestrowvalue || cmt === undefined) {
                cmt = worldgrid.highestrowvalue;
              } else {
                cmt -= tilesize;
              }
            }
        if (negative === false) {
              if (cmt === worldgrid.highestrowvalue || cmt === undefined) {
                cmt = worldgrid.lowestrowvalue;
              } else {
                cmt += tilesize;
              }
            }
        
        const vecn = ["x: ", "y:", "z: "];
        const j = vecn[vector] + cmt;
        const groupindex = worldgrid.groups.findIndex((element) => element === j);
        //console.log("vector: " + vecn[vector] + cmt + " index is " + groupindex);
    
        if (resettracker) cmt = undefined;
    
        //groups
        const group = worldgrid.groups[groupindex + 1].chunks;
        for (let j = 0; j < group.length; j++) {
          const chunk = group[j];
          let newvector = new THREE.Vector3(0, 0, 0);
    
    
          if (chunk.isBox3 === true) {
            if (negative === true) {
              //negative
              if (vector === 0) {
                //X
                newvector.set(chunk.centerv.x * -2 - tilesize, 0, 0);
              }
              if (vector === 2) {
                //Z
                newvector.set(0, 0, chunk.centerv.z * 2 - tilesize);
              }
            }
            if (negative === false) {
              //postive
              if (vector === 0) {
                //X
                newvector.set(chunk.centerv.x * 1 * 2 + tilesize, 0, 0);
              }
              if (vector === 2) {
                //Z
                newvector.set(0, 0, chunk.centerv.z * -1 * 2 + tilesize);
              }
            }
            chunk.translate(newvector);
          }
        }
      }

    //this regulates chunks
    for (let i = 0, il = worldgrid.chunks.length; i < il; i++) {
        const chunk = worldgrid.chunks[i];

        //dont touch very finkiny

        //////////////////////////WORLD GENERATION LOGIC///////////////////////////////////////////////

        //are we in the box, are we intersecting the box and is it not already rendered?
        if (
            
            (chunk.containsBox(camerabox) === true ||
                chunk.intersectsBox(camerabox) === true) &&
            chunk.rendered === false
        ) {
            if (chunk.mesh === null) {
                const height = rendertotexture(chunk, renderer)
              
                
                const planetexture = new THREE.MeshStandardMaterial({
                    wireframe: true,
                    map: height,
                    displacementMap: height,
                    displacementScale: 2,
                    displacementBias: Math.abs(2) * -0.5,
                });

                const plane = new THREE.PlaneGeometry(tilesize, tilesize, 100, 100).rotateX(-0.5 * Math.PI);
                const planemesh = new THREE.Mesh(plane, planetexture);
                planemesh.castShadow = true;
                planemesh.receiveShadow = true;
                chunk.mesh = planemesh;
                const v = chunk.getCenter(target);
                chunk.mesh.translateX(v.x);
                chunk.mesh.translateY(0);
                chunk.mesh.translateZ(v.z);

            }
            //Lets render it
            chunk.rendered = true;
            if (chunk.active){
              scene.add(chunk.mesh);
            } 
       
            
        }
        if (
            chunk.rendered === true &&
            chunk.containsBox(camerabox) === false &&
            chunk.intersectsBox(camerabox) === false
        ) {
            //we are not in that box but it is rendered..
            //we dont need it any more lets get rid of the mesh
            if (chunk.mesh !== null) {
                chunk.mesh.remove();
                scene.remove(chunk.mesh);
                chunk.mesh = null;
            }
            chunk.rttarget = null;
            chunk.rendered = false;
        }

        /////////////////////////////GRID UPDATE LOGIC//////////////////////////////////////////////////////

        //Are we in a new Box
        if (
            chunk.containsBox(innercamerabox) === true &&
            chunk.intersectsBox(innercamerabox) === true
        ) {
            if (!chunk.worldcenter) {
                //this is the center of the world now
                chunk.worldcenter = true;

                //lets get rid of our old center we cant used getObjectsByProperty because we are using box3 its not a object3d so its not registered to the scene
                let lastchunk;
                let direction;
                let negative;
                let updatelist = false;
                for (let v = 0, vi = worldgrid.chunks.length; v < vi; v++) {
                    const pchunk = worldgrid.chunks[v];
                    if (pchunk.worldcenter === true && chunk.id !== pchunk.id) {
                        lastchunk = pchunk;
                        pchunk.worldcenter = false;
                    }
                }

                if (lastchunk !== undefined) {
                    //figure out what direction
                    for (let mvk = 0; mvk < chunk.center.length; mvk++) {
                        const nvector = chunk.center[mvk];

                        for (let mlk = 0; mlk < lastchunk.center.length; mlk++) {
                            const ovector = lastchunk.center[mlk];
                            //is the vector different? e.g -20 > -10
                            if (mvk === mlk) {
                                if ((nvector === ovector * -1) && (ovector !== 0 && nvector !== 0)) {
                                    if (nvector < ovector) {
                                        direction = mvk
                                        negative = false;
                                    }
                                    if (nvector > ovector) {
                                        direction = mvk
                                        negative = true;
                                    }
                                } else {
                                    if (nvector > ovector) {
                                        direction = mvk;
                                        negative = false;
                                    }
                                    if (nvector < ovector) {
                                        direction = mvk
                                        negative = true;

                                    }
                                }

                            }
                        }
                    }
                    //we need to upgrade the grid in a way to keep the camera in the center TODO: The corners and multidirections
                    //YEah no
                    movegrid(direction, negative, false, tilesize)
                    //setheightcpu(chunk)

                }
            }
        }
    }



}